module.exports = __webpack_public_path__ + "static/img/pests.594519e5.png";